import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import officeBuilding from '@iconify/icons-mdi/office-building';
import briefcase from '@iconify/icons-eva/briefcase-fill';
import fileDocument from '@iconify/icons-mdi/file-document';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import lockFill from '@iconify/icons-eva/lock-fill';
import personAddFill from '@iconify/icons-eva/person-add-fill';
import alertTriangleFill from '@iconify/icons-eva/alert-triangle-fill';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(pieChart2Fill)
  },
  {
    title: 'user',
    path: '/dashboard/users',
    icon: getIcon(peopleFill)
  },
  {
    title: 'company',
    path: '/dashboard/companies',
    icon: getIcon(officeBuilding)
  },
  {
    title: 'job',
    path: '/dashboard/jobs',
    icon: getIcon(briefcase)
  },
  {
    title: 'candidate',
    path: '/dashboard/candidates',
    icon: getIcon(peopleFill)
  },
  {
    title: 'resume',
    path: '/dashboard/resumes',
    icon: getIcon(fileDocument)
  }
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: getIcon(lockFill)
  // },
  // {
  //   title: 'register',
  //   path: '/register',
  //   icon: getIcon(personAddFill)
  // },
  // {
  //   title: 'blog',
  //   path: '/dashboard/blog',
  //   icon: getIcon(fileTextFill)
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: getIcon(alertTriangleFill)
  // }
];

export default sidebarConfig;
